import { createStyles, Theme } from "@material-ui/core";
export const addContentStyles = (theme: Theme) => createStyles({
    root: {
        flex: 'grow'
    },
    tabsAlign: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textAlignRight: {
        textAlign: "right"
    },
    addButtonAlign: {
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'row-reverse'
    },
    chooseFromLibraryButton: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-around'

    },
    mb1x: {
        marginBottom: theme.spacing.unit
    },
    // oRText: {
    //     display: 'flex',
    //     marginBottom: theme.spacing.unit,
    //     justifyContent: 'space-around'

    // },
    questionParagraph: {
        maxWidth: 380,
        '& >p': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            margin: '0',
        }
    },
    questionInfo: {
        border: `1px solid ${theme.palette.grey[300]}`,
        "& > div": {
            padding: `0 ${theme.spacing.unit}px`
        },
        "& > div:first-child": {
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            borderRight: `1px solid ${theme.palette.grey[300]}`
        }
    },
    optionContent: {
        "& .btn-delete": {
            visibility: "visible"
        },
        '& p>img': {
            maxWidth: '100%'
        }
    },
    questionActionBtn: {
        padding: theme.spacing.unit,
        minWidth: "auto",
        backgroundColor: theme.palette.grey[200],
        border: `1px solid ${theme.palette.grey[300]}`,
        color: theme.palette.text.secondary,
        borderRadius: 0
    },
    buttonAlign: {
        display: 'flex',
        alignContent: 'center',
    },

    notesBlockTitle: {
        fontSize: 20,
        fontWeight: 400,
        paddingTop: 20,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'Nunito',
    },
    tabsNotes: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
        marginBottom: '15px',
    },
    tabsContainer: {
        border: 'solid 1px #E1E1E1',
        margin: '0 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    tabsContainer2: {
        border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    searchNotesinput: {
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
        fontStyle: "italic",
        '& input': {
            paddingLeft: "40px",
        },
    },
    OrDivider: {
        margin: "25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        "position": "absolute",
        "top": "-20px",
        left: '47%',
    },
    dividerBar: {
        "position": "absolute",
        "left": 0,
        "top": "15px",
        width: "100%",
        "content": " ",
        height: "1px",
        background: "#E0E6E7",
        "z-index": "1",
    },
    textAlignCenter: {
        textAlign: "center",
    },
    perfectScrollbar: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit,
        marginTop: '40px',
        // paddingBottom: theme.spacing.unit,
        maxHeight: 'inherit',
        background: 'rgb(255, 255, 255)',
        borderRadius: 4,
        '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
            opacity: 1
        },
        paddingBottom: 24
    },

    addPageMore: {
        background: '#FFF !important',
        color: '#1D7DEA !important',
        width: '100',
        marginRight: 6,
        border: '1px solid #1D7DEA',
        boxSizing: 'border-box',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    seachQuestionText: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
    },
    containerBorder: {

    },
    backIconRoot: {
        fill: theme.palette.text.secondary,
        fontSize: 24,
        opacity: 0.5,
        marginBottom: 3
    },
    imgSearch: {
        "position": "absolute",
        "left": "30px",
        "top": "54px",
        "z-index": "1",
    },
    ". MuiTab-root-355": {
        fontSize: "1.25rem !important",
    },
    selectedQues: {
        paddingRight: '20px',
    },
    dialogContent: {
        padding: 0,
        maxHeight: '100%',
        marginTop: 20
    },
    mandatory: {
        color: 'red',
    },
    ".MuiPrivateTabIndicator-colorPrimary-343": {
        backgroundColor: 'none !important',
    },
    ".MuiPrivateTabIndicator-root-342": {
        display: "none !important",
    },
    cardHeading: {
        fontWeight: theme.typography.fontWeightRegular,
        paddingTop: "15px",
    },
    dialogTitle: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        backgroundColor: 'white',
        '& > h6 > div': {
            minHeight: theme.spacing.unit * 7,
        },
        textTransform: 'capitalize',
        borderBottom: '1px solid rgb(226 226 226)',
        position: 'fixed',
        zIndex: 1001,
        top: 0,
        left: 0,
        right: 0
    },
    notesTitle: {
        border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 16,
            lineHeight: "22px",
            color: "#333333",
            fontFamily: 'Nunito',
            display: "block",
            paddingBottom: "20px"
        },
    },
    greyBgPanel: {
        backgroundColor: '#ccc',
        '& .MuiExpansionPanelDetails-root-321': {
            backgroundColor: "#F2F5F6 !important",
        },
    },


});